import type { CrmMessages } from "./englishCrmMessages";

export const portugueseCrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nome da empresa",
        website: "Site",
        linkedin_url: "LinkedIn",
        phone_number: "Telefone",
        created_at: "Data de criação",
        nb_contacts: "Número de contatos",
        revenue: "Faturamento",
        sector: "Setor",
        size: "Porte",
        tax_identifier: "CNPJ / Identificador fiscal",
        address: "Endereço",
        city: "Cidade",
        zipcode: "CEP",
        state_abbr: "UF",
        country: "País",
        description: "Descrição",
        context_links: "Links de contexto",
        sales_id: "Responsável",
      },
      empty: {
        description: "Sua lista de empresas está vazia.",
        title: "Nenhuma empresa encontrada",
      },
      field_categories: {
        contact: "Contato",
        additional_info: "Informações adicionais",
        address: "Endereço",
        context: "Contexto",
      },
      action: {
        create: "Criar Empresa",
        edit: "Editar empresa",
        new: "Nova Empresa",
        show: "Ver empresa",
      },
      added_on: "Adicionada em %{date}",
      followed_by: "Responsável: %{name}",
      followed_by_you: "Você é o responsável",
      no_contacts: "Nenhum contato",
      nb_contacts: "%{smart_count} contato |||| %{smart_count} contatos",
      nb_deals: "%{smart_count} negócio |||| %{smart_count} negócios",
      sizes: {
        one_employee: "1 funcionário",
        two_to_nine_employees: "2-9 funcionários",
        ten_to_forty_nine_employees: "10-49 funcionários",
        fifty_to_two_hundred_forty_nine_employees: "50-249 funcionários",
        two_hundred_fifty_or_more_employees: "250 ou mais funcionários",
      },
      autocomplete: {
        create_error: "Ocorreu um erro ao criar a empresa",
        create_item: "Criar %{item}",
        create_label: "Digite para criar uma nova empresa",
      },
      filters: {
        only_mine: "Apenas minhas empresas",
      },
    },
    contacts: {
      name: "Contato |||| Contatos",
      forcedCaseName: "Contato",
      field_categories: {
        background_info: "Histórico e observações",
        identity: "Identificação",
        misc: "Outros",
        personal_info: "Informações pessoais",
        position: "Cargo e empresa",
      },
      fields: {
        first_name: "Nome",
        last_name: "Sobrenome",
        last_seen: "Visto por último",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "Endereços de e-mail",
        email: "E-mail",
        phone_jsonb: "Telefones",
        phone_number: "Telefone",
        linkedin_url: "LinkedIn",
        background: "Observações (bio, como conheceu, etc.)",
        has_newsletter: "Recebe newsletter",
        sales_id: "Responsável",
      },
      action: {
        add: "Adicionar contato",
        add_first: "Adicionar primeiro contato",
        create: "Criar contato",
        edit: "Editar contato",
        export_vcard: "Exportar vCard",
        new: "Novo Contato",
        show: "Ver contato",
      },
      background: {
        last_activity_on: "Última atividade em %{date}",
        added_on: "Adicionado em %{date}",
        followed_by: "Responsável: %{name}",
        followed_by_you: "Você é o responsável",
        status_none: "Nenhum",
      },
      position_at: "%{title} na",
      position_at_company: "%{title} na %{company}",
      empty: {
        description: "Sua lista de contatos está vazia.",
        title: "Nenhum contato encontrado",
      },
      import: {
        title: "Importar contatos",
        button: "Importar CSV",
        complete:
          "Importação concluída. %{importCount} contatos importados, com %{errorCount} erros.",
        progress:
          "Importando %{importCount} / %{rowCount} contatos, com %{errorCount} erros.",
        error:
          "Falha ao importar o arquivo. Certifique-se de que é um CSV válido.",
        imported: "Importados",
        remaining_time: "Tempo restante estimado:",
        running: "Importação em andamento, não feche esta aba.",
        sample_download: "Baixar modelo CSV",
        sample_hint: "Aqui está um modelo de planilha que você pode usar:",
        stop: "Interromper importação",
        csv_file: "Arquivo CSV",
        contacts_label: "contato |||| contatos",
      },
      inputs: {
        genders: {
          male: "Ele/Dele",
          female: "Ela/Dela",
          nonbinary: "Elu/Delu",
        },
        personal_info_types: {
          work: "Trabalho",
          home: "Pessoal",
          other: "Outro",
        },
      },
      list: {
        error_loading: "Erro ao carregar contatos",
      },
      bulk_tag: {
        action: "Adicionar tag",
        back: "Voltar para tags",
        create_description:
          "Crie uma nova tag e aplique aos contatos selecionados.",
        description:
          "Escolha uma tag existente ou crie uma nova para os contatos selecionados.",
        empty: "Nenhuma tag ainda. Crie uma para aplicar aos contatos.",
        error: "Falha ao aplicar tag aos contatos",
        noop: "Os contatos selecionados já possuem esta tag",
        success:
          "Tag adicionada a %{smart_count} contato |||| Tag adicionada a %{smart_count} contatos",
        title: "Adicionar tag aos contatos",
      },
      merge: {
        action: "Mesclar com outro contato",
        confirm: "Mesclar Contatos",
        current_contact: "Contato Atual (será removido)",
        description: "Mescle este contato com outro duplicado.",
        error: "Falha ao mesclar contatos",
        merging: "Mesclando...",
        no_additional_data: "Nenhum dado adicional para mesclar",
        select_target: "Selecione um contato para mesclar",
        success: "Contatos mesclados com sucesso",
        target_contact: "Contato Principal (será mantido)",
        title: "Mesclar Contato",
        warning_description:
          "Todos os dados serão transferidos para o contato principal. Esta ação não pode ser desfeita.",
        warning_title: "Atenção: Ação irreversível",
        what_will_be_merged: "O que será unificado:",
      },
      filters: {
        before_last_month: "Antes do mês passado",
        before_this_month: "Antes deste mês",
        before_this_week: "Antes desta semana",
        managed_by_me: "Gerenciados por mim",
        search: "Buscar por nome, empresa...",
        this_week: "Esta semana",
        today: "Hoje",
        tags: "Tags",
        tasks: "Tarefas",
      },
      hot: {
        empty_change_status:
          "Altere a temperatura de um contato adicionando uma anotação.",
        empty_hint: 'Contatos marcados como "Quente" aparecerão aqui.',
        title: "Contatos Quentes",
      },
    },
    deals: {
      name: "Negócio |||| Negócios",
      fields: {
        name: "Título do Negócio",
        description: "Descrição",
        company_id: "Empresa",
        contact_ids: "Contatos",
        category: "Categoria",
        amount: "Valor Estimado",
        expected_closing_date: "Previsão de Fechamento",
        stage: "Etapa",
      },
      action: {
        back_to_deal: "Voltar para o negócio",
        create: "Criar Negócio",
        new: "Novo Negócio",
      },
      field_categories: {
        misc: "Informações do Negócio",
      },
      archived: {
        action: "Arquivar",
        error: "Erro: negócio não arquivado",
        list_title: "Negócios Arquivados",
        success: "Negócio arquivado com sucesso",
        title: "Negócio Arquivado",
        view: "Ver negócios arquivados",
      },
      inputs: {
        linked_to: "Vinculado a",
      },
      unarchived: {
        action: "Enviar de volta ao funil",
        error: "Erro: negócio não desarquivado",
        success: "Negócio restaurado para o funil",
      },
      updated: "Negócio atualizado",
      empty: {
        before_create: "antes de criar um negócio.",
        description: "Seu funil de negócios está vazio nesta etapa.",
        title: "Nenhum negócio encontrado",
      },
      invalid_date: "Data inválida",
    },
    notes: {
      name: "Anotação |||| Anotações",
      forcedCaseName: "Anotação",
      fields: {
        status: "Status",
        date: "Data",
        attachments: "Anexos",
        contact_id: "Contato",
        deal_id: "Negócio",
      },
      action: {
        add: "Adicionar anotação",
        add_first: "Adicionar primeira anotação",
        delete: "Excluir anotação",
        edit: "Editar anotação",
        update: "Atualizar anotação",
        add_this: "Salvar anotação",
      },
      sheet: {
        create: "Criar anotação",
        create_for: "Criar anotação para %{name}",
        edit: "Editar anotação",
        edit_for: "Editar anotação para %{name}",
      },
      deleted: "Anotação excluída",
      empty: "Nenhuma anotação registrada ainda",
      author_added: "%{name} adicionou uma anotação",
      you_added: "Você adicionou uma anotação",
      me: "Eu",
      list: {
        error_loading: "Erro ao carregar anotações",
      },
      note_for_contact: "Anotação para %{name}",
      stepper: {
        hint: "Acesse a página de um contato e adicione uma nota",
      },
      added: "Anotação adicionada com sucesso",
      inputs: {
        add_note: "Escreva uma anotação...",
        options_hint: "(anexar arquivos ou alterar detalhes)",
        show_options: "Mais opções",
      },
      actions: {
        attach_document: "Anexar documento",
      },
      validation: {
        note_or_attachment_required:
          "É necessário escrever uma anotação ou anexar um arquivo",
      },
    },
    sales: {
      name: "Usuário |||| Usuários",
      fields: {
        first_name: "Nome",
        last_name: "Sobrenome",
        email: "E-mail",
        administrator: "Administrador",
        disabled: "Desativado",
      },
      create: {
        error: "Ocorreu um erro ao criar o usuário.",
        success:
          "Usuário criado com sucesso. Um e-mail foi enviado para definição de senha.",
        title: "Criar novo usuário",
      },
      edit: {
        error: "Ocorreu um erro. Tente novamente.",
        record_not_found: "Usuário não encontrado",
        success: "Usuário atualizado com sucesso",
        title: "Editar %{name}",
      },
      action: {
        new: "Novo Usuário",
      },
    },
    tasks: {
      name: "Tarefa |||| Tarefas",
      forcedCaseName: "Tarefa",
      fields: {
        text: "Descrição da tarefa",
        due_date: "Prazo / Data de vencimento",
        type: "Tipo de tarefa",
        contact_id: "Contato",
        due_short: "vence em",
      },
      action: {
        add: "Adicionar tarefa",
        create: "Criar tarefa",
        edit: "Editar tarefa",
      },
      actions: {
        postpone_next_week: "Adiar para a próxima semana",
        postpone_tomorrow: "Adiar para amanhã",
        title: "Ações da tarefa",
      },
      added: "Tarefa adicionada",
      deleted: "Tarefa excluída com sucesso",
      dialog: {
        create: "Criar tarefa",
        create_for: "Criar tarefa para %{name}",
      },
      sheet: {
        edit: "Editar tarefa",
        edit_for: "Editar tarefa para %{name}",
      },
      empty: "Nenhuma tarefa pendente",
      empty_list_hint: "Tarefas atribuídas aos seus contatos aparecerão aqui.",
      filters: {
        later: "Mais tarde",
        overdue: "Atrasadas",
        this_week: "Esta semana",
        today: "Hoje",
        tomorrow: "Amanhã",
        with_pending: "Com tarefas pendentes",
      },
      regarding_contact: "(Ref: %{name})",
      updated: "Tarefa atualizada",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Adicionar tag",
        create: "Criar nova tag",
      },
      dialog: {
        color: "Cor",
        create_title: "Criar nova tag",
        edit_title: "Editar tag",
        name_label: "Nome da tag",
        name_placeholder: "Digite o nome da tag",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Redefinir Senha",
    },
    auth: {
      first_name: "Nome",
      last_name: "Sobrenome",
      confirm_password: "Confirmar senha",
      confirmation_required:
        "Verifique o link enviado ao seu e-mail para ativar sua conta.",
      recovery_email_sent:
        "Se o e-mail estiver cadastrado, você receberá instruções de redefinição em instantes.",
      sign_in_failed: "Falha ao entrar.",
      sign_in_google_workspace: "Entrar com Google",
      signup: {
        create_account: "Criar conta",
        create_first_user:
          "Crie a primeira conta de administrador para concluir a instalação.",
        creating: "Criando conta...",
        initial_user_created: "Usuário inicial criado com sucesso",
      },
      welcome_title: "Bem-vindo ao Dotus CRM",
    },
    common: {
      activity: "Atividade",
      added: "adicionou",
      details: "Detalhes",
      last_activity_with_date: "última atividade em %{date}",
      load_more: "Carregar mais",
      misc: "Outros",
      past: "Anteriores",
      read_more: "Ver mais",
      retry: "Tentar novamente",
      show_less: "Ver menos",
      copied: "Copiado!",
      copy: "Copiar",
      loading: "Carregando...",
      me: "Eu",
      task_count: "%{smart_count} tarefa |||| %{smart_count} tarefas",
    },
    changelog: {
      title: "Novidades e Atualizações",
    },
    activity: {
      added_company: "%{name} adicionou a empresa",
      you_added_company: "Você adicionou a empresa",
      added_contact: "%{name} adicionou",
      you_added_contact: "Você adicionou",
      added_note: "%{name} adicionou uma anotação sobre",
      you_added_note: "Você adicionou uma anotação sobre",
      added_note_about_deal: "%{name} adicionou uma anotação no negócio",
      you_added_note_about_deal: "Você adicionou uma anotação no negócio",
      added_deal: "%{name} criou o negócio",
      you_added_deal: "Você criou o negócio",
      at_company: "na",
      to: "para",
      load_more: "Carregar mais atividades",
    },
    dashboard: {
      deals_chart: "Previsão de Faturamento dos Negócios",
      deals_pipeline: "Funil de Vendas",
      latest_activity: "Últimas Atividades",
      latest_activity_error: "Erro ao carregar últimas atividades",
      latest_notes: "Minhas Últimas Anotações",
      latest_notes_added_ago: "adicionada há %{timeAgo}",
      stepper: {
        install: "Configurar Dotus CRM",
        progress: "%{step}/3 concluído",
        whats_next: "Próximos passos",
      },
      upcoming_tasks: "Próximas Tarefas",
    },
    header: {
      import_data: "Importar dados",
    },
    image_editor: {
      change: "Alterar",
      drop_hint: "Arraste uma imagem ou clique para selecionar.",
      editable_content: "Conteúdo editável",
      title: "Enviar e ajustar imagem",
      update_image: "Salvar Imagem",
    },
    import: {
      action: {
        download_error_report: "Baixar relatório de erros",
        import: "Importar",
        import_another: "Importar outro arquivo",
      },
      error: {
        unable: "Não foi possível importar este arquivo.",
      },
      idle: {
        description_1:
          "Você pode importar empresas, contatos, notas e tarefas.",
        description_2:
          "Os dados devem estar em um arquivo JSON ou CSV estruturado conforme o exemplo:",
      },
      status: {
        all_success: "Todos os registros foram importados com sucesso.",
        complete: "Importação concluída.",
        failed: "Falhou",
        imported: "Importado",
        in_progress:
          "Importação em andamento, por favor não feche esta página.",
        some_failed: "Alguns registros apresentaram erros.",
        table_caption: "Status da importação",
      },
      title: "Importar Dados",
    },
    settings: {
      about: "Sobre",
      companies: {
        sectors: "Setores de Atuação",
      },
      dark_mode_logo: "Logo (Modo Escuro)",
      deals: {
        categories: "Categorias de Negócios",
        currency: "Moeda",
        pipeline_help:
          "Selecione quais etapas contam como negócios no pipeline.",
        pipeline_statuses: "Etapas de Ganho (Funil)",
        stages: "Etapas do Funil",
      },
      light_mode_logo: "Logo (Modo Claro)",
      notes: {
        statuses: "Status / Temperaturas das Anotações",
      },
      reset_defaults: "Restaurar Padrões",
      save_error: "Erro ao salvar configurações",
      saved: "Configurações salvas com sucesso!",
      saving: "Salvando...",
      tasks: {
        types: "Tipos de Tarefas",
      },
      preferences: "Preferências",
      title: "Configurações",
      app_title: "Título do Aplicativo",
      sections: {
        branding: "Identidade Visual",
        data_fields: "Campos e Dados",
      },
      validation: {
        duplicate: "%{display_name} duplicado(a): %{items}",
        in_use:
          "Não é possível remover %{display_name} em uso por negócios ativos: %{items}",
        validating: "Validando...",
        entities: {
          categories: "categorias",
          stages: "etapas",
        },
      },
    },
    theme: {
      dark: "Escuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
    },
    language: "Idioma",
    navigation: {
      label: "Navegação do CRM",
    },
    profile: {
      inbound: {
        description:
          "Você pode encaminhar e-mails para o endereço de captura do CRM para que sejam transformados automaticamente em notas.",
        title: "Captura de E-mails",
      },
      mcp: {
        title: "Servidor MCP (IA)",
        description:
          "Conecte assistentes de IA diretamente aos dados do seu CRM através do protocolo MCP.",
      },
      password: {
        change: "Alterar senha",
      },
      password_reset_sent:
        "Um e-mail de redefinição de senha foi enviado para seu endereço",
      record_not_found: "Registro não encontrado",
      title: "Meu Perfil",
      updated: "Seu perfil foi atualizado com sucesso",
      update_error: "Ocorreu um erro. Tente novamente",
    },
    validation: {
      invalid_url: "Informe uma URL válida",
      invalid_linkedin_url: "A URL deve ser do linkedin.com",
    },
  },
} satisfies CrmMessages;
